module.exports = __webpack_public_path__ + "img/logo-text.c9d6ce7b.svg";